import '@/plugins/veevalidate';
import '@/plugins/vue-analytics-interface';
import gAuthConfig from '@/plugins/vue-google-oauth2/vueGoogleOauth2Config';
import '@/plugins/vue2-google-maps/vue2-google-maps';
import '@/plugins/vue2-hammer';
import '@/plugins/vuetify-loader';
import VeeValidate from 'vee-validate';
import Vue from 'vue';
import VueAnalytics from 'vue-analytics';
import gAuth from 'vue-google-oauth2';
import App from './App.vue';
import './plugins/class-component-hooks';
import './registerServiceWorker';
import router from './router';
import store from './store';

// const mainPath = window.location.hostname === 'localhost' ? 'http://localhost:8080' : 'https://papyrus.luxtagofficial.now.sh';

Vue.use(gAuth, gAuthConfig);

Vue.use(VueAnalytics, {
    id: window.location.hostname === 'localhost' ? 'UA-145843021-1' : 'UA-145833649-1',
    router,
});

Vue.config.productionTip = false;
Vue.use(VeeValidate, { delay: 1 });

new Vue({
    $_veeValidate: {
        validator: 'new',
    },
    router,
    store,
    render: h => h(App),
}).$mount('#app');
